import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SERVICE_LEVEL_URL } from '../../../constants/paths/api';
import Button from '../../base/button';
import { Input } from '../../base/forms/input';
import { RawLoader } from '../../loading/loading';
import * as StyledServiceLevel from './serviceLevel.styles';
import ServiceLevelCards from './serviceLevelCards';

interface Props {
	active: boolean;
}

const ServiceLevel: FC<Props> = ({ active }) => {
	const [value, setValue] = useState('');
	const [data, setData] = useState(null);
	const [filteredData, setFilteredData] = useState(null);
	const [cardsToShow, setCardsToShow] = useState(12);
	const { t } = useTranslation('generalPostInfo');

	const onChange = async e => {
		setValue(e.target.value);
		try {
			const lowerCaseValue = e.target.value.toLowerCase();
			if (lowerCaseValue.length !== 0) {
				const filtered = data.filter(postbox => {
					if (
						postbox.postcode.toString().indexOf(lowerCaseValue) !== -1 ||
						postbox.city.toLowerCase().indexOf(lowerCaseValue) !== -1 ||
						postbox.postoffice.toLowerCase().indexOf(lowerCaseValue) !== -1
					) {
						return true;
					}
					return false;
				});
				setFilteredData(filtered);
			} else {
				setFilteredData(null);
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (!data && active) {
			axios(`${SERVICE_LEVEL_URL}`).then(homeAndCompaniesData => {
				setData(homeAndCompaniesData.data);
			});
		}
	}, [data, setData, active]);

	return (
		<StyledServiceLevel.Wrapper>
			<StyledServiceLevel.InputWrapper>
				<Input type="text" value={value} onChange={onChange} placeholder={`${t('address-search.search')}...`} />
			</StyledServiceLevel.InputWrapper>
			{data && (
				<>
					<StyledServiceLevel.TableWrapper>
						<ServiceLevelCards data={filteredData || data} cardsToShow={cardsToShow} />
					</StyledServiceLevel.TableWrapper>
					<StyledServiceLevel.SeeMoreContainer>
						<Button onClick={() => setCardsToShow(cardsToShow + 12)}>{t('service-level.see-more')}</Button>
					</StyledServiceLevel.SeeMoreContainer>
				</>
			)}
			{!data && (
				<StyledServiceLevel.LoaderContainer>
					<RawLoader />
				</StyledServiceLevel.LoaderContainer>
			)}
		</StyledServiceLevel.Wrapper>
	);
};

export default ServiceLevel;
